import { TEXT_TAGS, TEXT_VARIANTS } from '../../theme/font';

import PropTypes from 'prop-types';
import React from 'react';
import ShowMoreText from '../ShowMoreText';
import Text from '../Typography/Text';
import Wysiwyg from '../Wysiwyg';
import styled from 'styled-components';

const Wrapper = styled.div`
  margin-bottom: 40px;
`;

const BlockContent = ({ children, variant, color, as, wysiwyg, showMore }) => {
  const ShowMoreTextWrapper = showMore ? ShowMoreText : 'div';
  return (
    <Wrapper>
      <ShowMoreTextWrapper>
        {wysiwyg ? (
          <Wysiwyg color={color} content={children} />
        ) : (
          <Text variant={variant} color={color} as={as}>
            {children}
          </Text>
        )}
      </ShowMoreTextWrapper>
    </Wrapper>
  );
};

BlockContent.propTypes = {
  variant: PropTypes.oneOf(TEXT_VARIANTS),
  as: PropTypes.oneOf(TEXT_TAGS),
  color: PropTypes.string,
  children: PropTypes.any,
  wysiwyg: PropTypes.bool,
  showMore: PropTypes.bool
};

export default BlockContent;
